
import React from 'react';
import { ArrowRight } from 'lucide-react';

const InnovationHighlights = () => {
  const innovations = [
    {
      year: '2024',
      title: 'Quantum-Ready Computing',
      description: 'Developing next-generation hardware compatible with quantum computing principles.'
    },
    {
      year: '2023',
      title: 'AI-Optimized Workstations',
      description: 'Custom-built systems designed specifically for machine learning and AI workflows.'
    },
    {
      year: '2022',
      title: 'Green Computing Initiative',
      description: 'Launch of eco-friendly hardware solutions with 50% reduced power consumption.'
    }
  ];

  return (
    <div className="mt-16 mb-8">
      <h3 className="text-2xl font-bold mb-8 text-center">Innovation Timeline</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {innovations.map((innovation, index) => (
          <div 
            key={index}
            className="group relative overflow-hidden rounded-xl bg-gradient-to-br from-primary/5 to-secondary/5 p-6 border border-border/50 hover:border-primary/50 transition-all duration-300"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative">
              <span className="text-4xl font-bold text-primary/50 mb-4 block">{innovation.year}</span>
              <h4 className="text-xl font-semibold mb-3">{innovation.title}</h4>
              <p className="text-muted-foreground">{innovation.description}</p>
              <ArrowRight className="w-5 h-5 text-primary mt-4 group-hover:translate-x-2 transition-transform duration-300" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InnovationHighlights;
